import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
//import {Root} from './App';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ScrollView } from 'devextreme-react/scroll-view';

// import './Style.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
                <ScrollView
                // height={800}
                // width={500}
                direction="vertical">  {/* or 'horizontal' | 'vertical' */}
                {/* Here goes long content */}
           
    <App />
    </ScrollView>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
